module.exports = __webpack_public_path__ + "fbba6baa42ef4a2127524b25087f3743.svg";